import React from 'react';
import { trackFbEvent } from '../utils/fbpixel';
export function PricingTable() {
  const standardUrl = 'https://biologiafemenina.com.ar/checkouts/cn/hWNAyoSYZJTJbTg7kMIErTs2/es-ar?_r=AQABYH4AJEYbldjv1X8ikRhvCxTQaIS18_dlVcs3rsXEGpw';
  const vipUrl = 'https://biologiafemenina.com.ar/checkouts/cn/hWNAyoLK7WK3TzXI3v5RGX0k/es-ar?_r=AQABT_wKLpoN4NHawYiBZBU4FMM4DkBu3EjImLlsMOvhfHk';
  return <section id="compra" className="w-full bg-[#F8F5FC] px-4 py-3 sm:py-12 flex flex-col justify-center" style={{
    scrollMarginTop: 'calc(env(safe-area-inset-top, 0px) + 0.5rem)',
    minHeight: '100dvh'
  }} data-id="element-187">
      <div className="max-w-5xl mx-auto w-full" data-id="element-188">
        <h2 className="text-[18px] sm:text-[28px] font-bold text-brand-text text-center mb-3 sm:mb-8 leading-tight" data-id="element-189">
          Elegí tu plan:
        </h2>

        <div className="flex flex-col gap-2.5 sm:gap-5 mb-3 sm:mb-8 max-w-md mx-auto" data-id="element-190">
          {/* Card 1: Standard */}
          <div className="bg-white rounded-[14px] p-3 border border-brand-gray shadow-[0_4px_24px_rgba(0,0,0,0.04)]" data-id="element-191">
            <div className="flex items-start justify-between gap-2 mb-2" data-id="element-192">
              <div className="min-w-0 flex-1" data-id="element-193">
                <span className="text-brand-violet text-[9px] font-bold uppercase tracking-wider block leading-tight mb-0.5" data-id="element-194">
                  ⭐ SISTEMA ORIGINAL
                </span>
                <h3 className="text-[14px] font-bold text-brand-text leading-tight" data-id="element-195">
                  Método pH-ZERO
                </h3>
                <p className="text-brand-muted text-[11px] leading-tight" data-id="element-196">
                  6 Tomos + 3 Bonus
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-197">
                <p className="text-brand-muted text-[10px] line-through leading-tight" data-id="element-198">
                  $39.990
                </p>
                <p className="text-brand-text text-[20px] font-bold leading-tight" data-id="element-199">
                  $19.990
                </p>
              </div>
            </div>
            <a href={standardUrl} target="_blank" rel="noopener noreferrer" onClick={() => trackFbEvent('InitiateCheckout', {
            content_name: 'Sistema Original',
            value: 19990,
            currency: 'ARS'
          })} className="w-full block bg-brand-violet hover:brightness-110 text-white font-bold text-[12px] rounded-lg py-2 text-center transition-all" data-id="element-200">
              QUIERO SISTEMA ORIGINAL
            </a>
          </div>

          {/* Card 2: VIP */}
          <div className="bg-white rounded-[14px] p-3 border-2 border-brand-violet shadow-[0_8px_32px_rgba(74,0,128,0.15)] relative" data-id="element-201">
            <div className="absolute -top-2 right-3 bg-brand-magenta text-white text-[8px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full" data-id="element-202">
              MÁS ELEGIDO
            </div>
            <span className="text-brand-violet text-[9px] font-bold uppercase tracking-wider block leading-tight mb-1" data-id="element-203">
              🏆 LA MEJOR OPCIÓN
            </span>
            <div className="flex items-start justify-between gap-2 mb-2" data-id="element-204">
              <div className="min-w-0 flex-1" data-id="element-205">
                <h3 className="text-[14px] font-bold text-brand-text leading-tight" data-id="element-206">
                  👑 PACK COMPLETO
                </h3>
                <p className="text-brand-text font-bold text-[12px] leading-tight" data-id="element-207">
                  Libertad Total 💎
                </p>
                <p className="text-brand-muted text-[10px] leading-tight" data-id="element-208">
                  Todo + NUTRICIONISTA + CUIDADOS
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-209">
                <p className="text-brand-muted text-[10px] line-through leading-tight" data-id="element-210">
                  $49.990
                </p>
                <p className="text-brand-text text-[20px] font-bold leading-tight" data-id="element-211">
                  $29.990
                </p>
              </div>
            </div>
            <a href={vipUrl} target="_blank" rel="noopener noreferrer" onClick={() => trackFbEvent('InitiateCheckout', {
            content_name: 'Pack VIP',
            value: 29990,
            currency: 'ARS'
          })} className="w-full block bg-brand-magenta hover:brightness-110 text-white font-bold text-[12px] rounded-lg py-2 text-center transition-all shadow-[0_4px_16px_rgba(212,0,110,0.25)]" data-id="element-212">
              ADQUIRIR PACK COMPLETO
            </a>
            <div className="hidden sm:flex flex-col gap-2 pt-4 mt-4 border-t border-brand-gray" data-id="element-213">
              <p className="text-[12px] text-brand-text leading-snug" data-id="element-214">
                🛒 <strong data-id="element-215">NUTRICIONISTA:</strong> Plan día por día con lista de
                súper.
              </p>
              <p className="text-[12px] text-brand-text leading-snug" data-id="element-216">
                🔍 <strong data-id="element-217">CUIDADOS:</strong> Blindaje contra pareja, ropa y
                químicos.
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center justify-center gap-1.5" data-id="element-218">
          <div className="flex items-center justify-center gap-2 sm:gap-4 text-brand-muted text-[9px] sm:text-[12px] font-medium" data-id="element-219">
            <span data-id="element-220">💳 Mercado Pago</span>
            <span data-id="element-221">·</span>
            <span data-id="element-222">🏦 Tarjetas</span>
            <span data-id="element-223">·</span>
            <span data-id="element-224">🔄 Transferencia</span>
          </div>
          <div className="bg-brand-gray rounded-lg px-2.5 py-1 flex items-center justify-center gap-1.5" data-id="element-225">
            <span className="text-[10px]" data-id="element-226">🛡️</span>
            <p className="text-[8px] sm:text-[11px] text-brand-muted font-medium leading-tight" data-id="element-227">
              <strong className="text-brand-text" data-id="element-228">Compra 100% segura</strong> ·
              Datos protegidos · Acceso inmediato · 🇦🇷
            </p>
          </div>
        </div>
      </div>
    </section>;
}